import { render, staticRenderFns } from "./LinkUserButtonDisplay.vue?vue&type=template&id=45c08b4d&scoped=true"
import script from "./LinkUserButtonDisplay.vue?vue&type=script&lang=js"
export * from "./LinkUserButtonDisplay.vue?vue&type=script&lang=js"
import style0 from "./LinkUserButtonDisplay.vue?vue&type=style&index=0&id=45c08b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c08b4d",
  null
  
)

export default component.exports